export const default_description =
  "Doitly - The professional marketplace connecting task posters with skilled service providers. Post any task and receive competitive proposals, or browse posted tasks to earn money with your skills. Get things done, big or small.";

export const default_keywords = [
  "Doitly",
  "task marketplace",
  "freelance services",
  "local services",
  "hire professionals",
  "post tasks",
  "service proposals",
  "skilled providers",
  "home services",
  "digital services",
  "handyman services",
  "house cleaning",
  "web development",
  "graphic design",
  "task posting",
  "earn money",
  "side hustle",
  "gig economy",
  "service marketplace",
  "professional services"
];

export const default_title = "Doitly - Professional Task Marketplace | Get Things Done";

export const site_name = "Doitly";
export const site_url = "https://doitly.co";
export const twitter_handle = "@doitly";
export const og_image = "https://doitly.co/og-image.jpg";
export const favicon_32 = "/favicon-32x32.png";
export const favicon_16 = "/favicon-16x16.png";
export const apple_touch_icon = "/apple-touch-icon.png";
